export const navItems = [
  { label: '首页', path: '/' },
  { label: '关于我们', path: '/about' },
  { label: '解决方案', path: '/services' },
  { label: '产品中心', path: '/cases' },
  { label: '平台介绍', path: '/news' },
  { label: '加入代理', path: '/talent' },
  { label: '联系我们', path: '/contact' }
]

export const services = [
  {
    title: 'GPS定位终端供应',
    desc: '覆盖微型、车载、太阳能、畜牧宠物等多类型GPS/北斗定位设备。'
  },
  {
    title: '定位平台定制开发',
    desc: '提供APP、Web、服务器和数据看板开发，支持多行业业务流程。'
  },
  {
    title: 'OEM/ODM交付服务',
    desc: '从硬件方案、软件功能到量产交付，为客户提供一站式定位服务。'
  }
]

export const cases = [
  { name: '迅驰捷运智能配送车辆监管项目', tag: '物流车辆', desc: '整合车载终端、物流管理平台和司机APP，提升运输过程可视化能力。' },
  { name: '金融风控资产定位项目', tag: '金融风控', desc: '通过电子围栏、轨迹回放和风险告警降低资产管理风险。' },
  { name: '畜牧宠物定位管理项目', tag: '智慧畜牧', desc: '使用低功耗定位终端与数据平台，实现位置追踪和异常提醒。' }
]

export const news = [
  { title: 'GPS定位终端在物流配送中的应用价值', date: '2026-06-01' },
  { title: '车辆风控场景如何选择定位设备', date: '2026-05-18' },
  { title: '从硬件到平台的一站式定位服务思路', date: '2026-05-06' }
]
